module.exports = __webpack_public_path__ + "components/about-header/static/header--small@2x-a5be80d8127238e78e1fa5d2e476e236.jpg";